<template>
  <div>
    <div class="query-container space-between">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="统计时间：">
            <el-date-picker
              @change="query"
              value-format="yyyy-MM-dd"
              v-model="param.date"
              type="date"
              placeholder="选择日期"
              :picker-options="{
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              }"
            ></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button style="width: 100px; margin-right: 20px" type="primary" @click="query"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div>
      <!-- 每日出车质检报告内容区域 -->
      <div class="report-container">
        <el-table :data="tableData" stripe border max-height="650" style="width: 100%">
          <el-table-column label="序号" type="index" width="50" fixed="left"></el-table-column>

          <!-- 固定列：司机信息 -->
          <el-table-column
            prop="driverNo"
            label="司机编号"
            width="80"
            fixed="left"
          ></el-table-column>
          <el-table-column
            prop="driverName"
            label="司机姓名"
            width="80"
            fixed="left"
          ></el-table-column>
          <el-table-column prop="pathId" label="路线" width="100" fixed="left">
            <template slot-scope="scope">
              {{ scope.row.pathId | pathNameTransfer }}
            </template>
          </el-table-column>
          <el-table-column
            prop="routeTime"
            label="行程时间"
            width="120"
            fixed="left"
          ></el-table-column>

          <!-- 动态列：质检项相关字段 -->
          <el-table-column
            v-for="column in tableColumns"
            :key="column.column"
            :prop="column.column"
            :label="column.columnName"
            :width="getColumnWidth(column.column)"
            :min-width="getMinWidth(column.column)"
            sortable
          >
            <template slot-scope="scope">
              <div v-if="isResultColumn(column.column)">
                <el-tag :type="getResultTagType(scope.row[column.column])" size="small">
                  {{ scope.row[column.column] || "未检查" }}
                </el-tag>
              </div>
              <div v-else-if="isResourcesColumn(column.column)">
                <div v-if="scope.row[column.column] && scope.row[column.column].length > 0">
                  <el-popover placement="top" width="400" trigger="click">
                    <div class="resource-list">
                      <div
                        v-for="(resource, index) in scope.row[column.column]"
                        :key="index"
                        class="resource-item"
                      >
                        <el-image
                          v-if="isImage(resource.url)"
                          :src="resource.url"
                          :preview-src-list="getPreviewList(scope.row[column.column])"
                          fit="cover"
                          style="width: 100px; height: 100px; margin-right: 10px"
                        ></el-image>
                        <video
                          v-else-if="isVideo(resource.url)"
                          :src="resource.url"
                          controls
                          style="width: 100px; height: 100px; margin-right: 10px"
                        ></video>
                        <audio
                          v-else-if="isAudio(resource.url)"
                          :src="resource.url"
                          controls
                          style="width: 200px; margin-right: 10px"
                        ></audio>
                        <div v-else class="other-file">
                          <el-link :href="resource.url" target="_blank" type="primary">
                            <i class="el-icon-document"></i> 查看文件
                          </el-link>
                        </div>
                        <div v-if="resource.remark" class="resource-remark">
                          {{ resource.remark }}
                        </div>
                      </div>
                    </div>
                    <el-button type="text" size="small" slot="reference">
                      查看佐证({{ scope.row[column.column].length }})
                    </el-button>
                  </el-popover>
                </div>
                <span v-else class="text-muted">-</span>
              </div>

              <div v-else-if="isPunishBillColumn(column.column)">
                <div v-if="scope.row[column.column] && scope.row[column.column].length > 0">
                  <el-link
                    v-for="(billId, index) in scope.row[column.column]"
                    :key="index"
                    type="primary"
                    @click="viewPunishBill(billId)"
                    style="margin-right: 8px"
                  >
                    <span style="font-size: 12px"> 罚单{{ index + 1 }}</span>
                  </el-link>
                </div>
                <span v-else class="text-muted">-</span>
              </div>
              <div v-else-if="isRemarkColumn(column.column)">
                <LongTextTooltip :text="scope.row[column.column]" :max-length="20" />
              </div>
              <div v-else>
                {{
                  scope.row[column.column] !== null && scope.row[column.column] !== undefined
                    ? scope.row[column.column]
                    : "-"
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="go2QcPage(scope.row.routeId)">
                质检详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getDailyQcResult, getPunishBill } from "@/api";
import { DateUtil } from "@/util";
import { SHOW_PUNISH_DIAG } from "@/core/const/global-event";
import Router from "@/route";
import LongTextTooltip from "./LongTextTooltip";

export default {
  components: {
    LongTextTooltip
  },
  props: {},
  created() {
    // 初始化日期为今天
    this.query();
  },
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      loading: false,
      param: {
        date: DateUtil.getDayStr(0)
      },
      tableColumns: [],
      tableData: []
    };
  },
  methods: {
    query() {
      if (!this.param.date) {
        this.$message.warning("请选择日期");
        return;
      }
      this.loading = true;
      getDailyQcResult(this.param.date)
        .then((res) => {
          const { columns = [], dataList = [] } = res.data || {};
          this.tableColumns = columns;
          this.tableData = dataList;
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("查询失败");
          this.loading = false;
        });
    },
    // 判断是否为结果列
    isResultColumn(column) {
      return column && column.endsWith("_result");
    },
    // 判断是否为资源列
    isResourcesColumn(column) {
      return column && column.endsWith("_resources");
    },

    // 判断是否为罚单列
    isPunishBillColumn(column) {
      return column && column.endsWith("_punishBillIds");
    },
    // 判断是否为备注列
    isRemarkColumn(column) {
      return column && column.endsWith("_remark");
    },
    // 获取结果文本
    getResultText(result) {
      const resultMap = {
        0: "不合格",
        1: "合格",
        2: "待改进",
        3: "未检查"
      };
      return resultMap[result] || "未知";
    },
    // 获取结果标签类型
    getResultTagType(result) {
      const typeMap = {
        不合格: "danger",
        合格: "success",
        待改进: "warning",
        未检查: "info"
      };
      return typeMap[result] || "info";
    },
    // 获取列宽度
    getColumnWidth(column) {
      if (this.isResultColumn(column)) return 100;
      if (this.isResourcesColumn(column)) return 120;
      if (this.isPunishBillColumn(column)) return 180;
      if (this.isRemarkColumn(column)) return 150;
      if (column && column.includes("Count")) return 100;
      return undefined;
    },
    // 获取最小宽度
    getMinWidth(column) {
      if (this.isResultColumn(column)) return 100;
      if (this.isResourcesColumn(column)) return 120;
      if (this.isPunishBillColumn(column)) return 180;
      if (this.isRemarkColumn(column)) return 150;
      if (column && column.includes("Count")) return 100;
      return 120;
    },
    // 判断是否为图片
    isImage(url) {
      if (!url) return false;
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
    },
    // 判断是否为视频
    isVideo(url) {
      if (!url) return false;
      return /\.(mp4|avi|mov|wmv|flv|webm)$/i.test(url);
    },
    // 判断是否为音频
    isAudio(url) {
      if (!url) return false;
      return /\.(mp3|wav|ogg|m4a)$/i.test(url);
    },
    // 获取预览列表
    getPreviewList(resources) {
      if (!resources || !Array.isArray(resources)) return [];
      return resources.filter((r) => r.url && this.isImage(r.url)).map((r) => r.url);
    },
    // 查看罚单
    async viewPunishBill(billId) {
      const resp = await getPunishBill(billId);
      this.$bus.$emit(SHOW_PUNISH_DIAG, { punishBill: resp.data, viewMode: true });
    },

    go2QcPage(routeId) {
      const { href } = Router.resolve({
        path: "/route/qc",
        query: { routeId }
      });
      window.open(href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.query-container {
  margin-bottom: 20px;
}

.report-container {
  margin-top: 20px;
}

.text-muted {
  color: #909399;
}

.resource-list {
  max-height: 400px;
  overflow-y: auto;

  .resource-item {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;

    &:last-child {
      border-bottom: none;
    }

    .resource-remark {
      margin-top: 5px;
      font-size: 12px;
      color: #909399;
    }

    .other-file {
      display: flex;
      align-items: center;
    }
  }
}

@media print {
  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: auto;
  }

  /* 隐藏查询区域 */
  .query-container {
    display: none;
  }

  /* 设置页面边距，确保每页都有上边距 */
  @page {
    size: A4;
    margin: 20mm;
  }

  /* 报告容器样式 */
  .report-container {
    margin-top: 0;
    width: 100%;

    /* 表格打印样式优化 */
    .el-table {
      width: 100% !important;
      max-height: none !important;
    }

    /* 确保表格在分页时正确显示 */
    .el-table__header-wrapper {
      display: table-header-group;
    }

    .el-table__body-wrapper {
      display: table-row-group;
    }
  }

  /* 防止表格行被截断 */
  .el-table__row {
    page-break-inside: avoid;
  }

  /* 确保表格表头在每页都显示 */
  .el-table thead {
    display: table-header-group;
  }

  /* 优化资源列表的打印显示 */
  .resource-list {
    max-height: none;
    overflow: visible;
  }
}
</style>
